import React, { useMemo, useState } from "react";
import { MenuItem, Select, OutlinedInput, useTheme } from "@mui/material";
import { styled } from "@mui/system";


// Ajouter des styles personnalisés pour le composant Select
const CustomOutlinedInput = styled(OutlinedInput, {
  shouldForwardProp: (prop) => prop !== 'role',
})(({ role }) => {
  const isOnet = role === "onet";
  const isCompass = role === "compass";

  return {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: isOnet ? '#06305C' : isCompass ? '#c4ac66' : '#F7E900',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: isOnet ? '#06305C' : isCompass ? '#c4ac66' : '#F7E900',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: isOnet ? '#06305C' : isCompass ? '#c4ac66' : '#F7E900',
      borderRadius: 7,
    },
    '& .MuiOutlinedInput-input': {
      padding: '10.5px 14px',
    },
    '& legend': {
      maxWidth: '0px',
    },
    '& span': {
      display: 'none'
    },
  };
});

const PluginFilter = ({ data, onFilterChange, sx, role }) => {
  const [filterInstance, setFilterInstance] = useState("all");
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const isOnet = role === "onet";
  const isCompass = role === "compass";

  // Mémoïsé : ce composant est monté dans l'en-tête de PluginDrawer, donc ce balayage
  // de toute la liste aplatie des plugins tombait dans la frame d'ouverture du Drawer.
  const instanceNames = useMemo(
    () => [
      ...new Set(
        (Array.isArray(data) ? data : []).flatMap((pluginGroup) => {
          if (!pluginGroup.sites || !Array.isArray(pluginGroup.sites)) return [];
          return pluginGroup.sites.map((site) =>
            (site.env || "").toUpperCase().trim()
          );
        })
      ),
    ],
    [data]
  );

  const handleFilterChange = (e) => {
    const instanceName = e.target.value;
    setFilterInstance(instanceName);
    onFilterChange(instanceName);
  };

  return (
      <Select
        key={`plugin-filter-${role}`}
        value={filterInstance}
        onChange={handleFilterChange}
        input={<CustomOutlinedInput label="Toutes les instances" role={role} />}
        sx={{
          height: "40px",
          color: theme.palette.text.primary,
          ...sx,
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: isOnet ? '#06305C'  : isCompass ? '#c4ac66' : '#F7E900',
            },
            '&:hover fieldset': {
              borderColor: isOnet ? '#06305C'  : isCompass ? '#c4ac66' : '#F7E900',
            },
            '&.Mui-focused fieldset': {
              borderColor: isOnet ? '#06305C'  : isCompass ? '#c4ac66' : '#F7E900',
            },
          },
          '& .MuiSelect-icon': {
            color: theme.palette.text.primary,
          }
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: isDark ? theme.palette.background.paper : '#FFF',
              '& .MuiMenuItem-root': {
                color: isDark ? theme.palette.text.primary : 'inherit',
                '&:hover': {
                  backgroundColor: isOnet
                    ? 'rgba(6, 48, 92, 0.08)'
                    : isCompass
                      ? 'rgba(196, 172, 102, 0.08)'
                      : isDark
                        ? 'rgba(255, 255, 255, 0.08)'
                        : 'rgba(247, 233, 0, 0.08)',
                },
                '&.Mui-selected': {
                  backgroundColor: isOnet
                    ? 'rgba(6, 48, 92, 0.12)'
                    : isCompass
                      ? 'rgba(196, 172, 102, 0.12)'
                      : isDark
                        ? 'rgba(255, 255, 255, 0.12)'
                        : 'rgba(247, 233, 0, 0.12)',
                  color: isDark ? '#FFFFFF' : '#000000',
                  fontWeight: isDark ? 'normal' : 'bold',
                },
                '&.Mui-selected:hover': {
                  backgroundColor: isOnet
                    ? 'rgba(6, 48, 92, 0.16)'
                    : isCompass
                      ? 'rgba(196, 172, 102, 0.16)'
                      : isDark
                        ? 'rgba(255, 255, 255, 0.16)'
                        : 'rgba(247, 233, 0, 0.16)',
                  color: isDark ? '#FFFFFF' : '#000000',
                },
              },
            },
          },
        }}
      >
        <MenuItem value="all">Toutes les instances</MenuItem>
        {instanceNames.map((instanceName) => (
          <MenuItem key={instanceName} value={instanceName}>
            {instanceName}
          </MenuItem>
        ))}
      </Select>
  );
};

export default PluginFilter;
